module.exports = __webpack_public_path__ + "img/logo_waste.d89e2fd4.png";